<template>
    <div id="topicClass" :class="authType ? 'selectTypeClass' : 'app-inner'">
              <div class="public-btn-div flex align-cen">
      <div class="public-add"  @click="addBus" v-if="!authType">
        新增分类
      </div>
           <div class="businessList_header flex align-cen mft">
            <el-input
            placeholder="请输入分类名称" 
            v-model="searchname"
            clearable
            >
            <i slot="prefix" class="el-input__icon el-icon-search" @click="search"></i>
        </el-input>
         <div class="businessList-filter-list flex align-cen public-btn-small" style="padding-left:0">
            <div class="public-btn-small-primary" @click="search">
          搜索
        </div>
        <div class="public-btn-small-text" @click="reset">
          重置筛选条件
        </div>
      </div>
     </div>
    </div>
          <div class="businessList-container">
        <div class="businessList-container-table">
             <el-table
             ref="multipleTable"
            :data="itemList"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            :row-key="getRowKeyOfTarget"
          @selection-change="handleSelectionChange"
          @select='onTableSelect'
            >
             <el-table-column type="selection" width="55" reserve-selection align="center" fixed="left" v-if="authType"> </el-table-column>
            <el-table-column
            prop="name"
            label="分类"
           align="center"
             >
             <template slot-scope="scope" >
               <div v-if="scope.row.sort == 0">
                    <p style="color:#000">{{scope.row.name}}</p>
                    <p style="font-size:13px"> {{scope.row.description}}</p>
               </div>
                <div v-else style="color:#000">
                {{scope.row.name}}
               </div>
              </template>
            </el-table-column>
            <el-table-column
            prop="sort"
            label="排序"
           align="center"
            >
            </el-table-column>
            <el-table-column
            prop="questionNum"
            label="题目数"
           align="center"
           v-if="authType"
            >
            </el-table-column>
            <el-table-column
            label="操作"
            align="center"
            v-if="!authType"
            >
              <template slot-scope="scope">
                <div  v-if="scope.row.sort != 0">
                    <el-button type="text" size="small" @click.stop="editPro(scope.row)">编辑</el-button>
                <el-button type="text" size="small" @click.stop="deletPro(scope.row)" class="daner" style="color:red">删除</el-button>
                </div>
                <div v-else>
                  <el-button type="text" size="small"  style="color:red">禁止操作</el-button>  
                </div>
              </template>
            </el-table-column>
        </el-table>
         <paginaTion :total="totalCount" @sendStatus="emitFun"  v-if="!authType"></paginaTion>
        </div>
      </div>
                 <!-- 增加修改弹窗 -->
      <el-dialog
  :title="tit"
  :visible.sync="centerDialogVisible"
  width="30%"
  :append-to-body="true"
  center>
   <div class="forminfo"
    v-loading="loading"
      element-loading-text="正在添加中..."
     element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
   >
    <el-form :model="formLabelAlign" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
         <el-form-item label="分类名称：" prop="name">
              <el-input v-model="formLabelAlign.name" clearable placeholder="20字以内" class="bbb"></el-input>
        </el-form-item>
         <el-form-item label="排序：">
              <el-input v-model.number="formLabelAlign.sort" clearable class="bbb" minlength="0" maxlength="5"></el-input>
        </el-form-item>
    </el-form>
     <div class="btn" @click="onsubmit('ruleForm')">确定</div>
   </div>
</el-dialog>
    </div>
</template>
<script>
import {getcertClassify,editCert,getCert,getAllCertClassify} from "@/api/index/index"  //题目分类、新增修改题目分类、删除题目分类
import debounce from '../../../../utils/debounce.js' //防抖
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
export default {
    name:'topicClass',
     components:{
      paginaTion
    },
     props: {
    authType:[String, Number],
    },
    data () {
         return {
           catchStatus:false,
          selsctarr:[],
          multipleSelection:[],
            searchname:'',
            loading:false,
            edittype:0,
            tit:'',
            centerDialogVisible:false,
            totalNum:0,
            currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount: 0,
            pageSizes:[10,20,30,40,50,100],
            itemList:[],
             formLabelAlign:{
            name:'',
            sort:'',
            id:''
        },
        rules: {
             name: [
             { required: true, message: '请正确填写分类名称', trigger: 'blur' },
             { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
          ],
        }
        }
    },
     activated() {
        this.gethisInfo()
    },
    created() {
        if(this.authType) this.gethisInfo1()
    },
    methods: {
       editfun(val){
            this.selsctarr = val        
        },
       // 新增修改调用清空方法
        remove(){
           this.multipleSelection = []
        },
        getRowKeyOfTarget(row) {
            return row.id
            },
                 // 手动选择
    onTableSelect(rows, row){
         this.catchStatus = rows.length && rows.indexOf(row) !== -1
    },
            // 表格选择
         handleSelectionChange(val) {
         this.multipleSelection = val;
                 for (const key in this.multipleSelection) {
              this.multipleSelection[key]['subQuestionNum'] = 0
              this.multipleSelection[key]['point'] = 0
              }
        this.$emit('sendStatus', this.multipleSelection,false)
      },
        // 新增
        addBus(){
            this.edittype = 0  //0表示新增项目，1表示修改项目
           this.tit = "新增证书分类"
           this.centerDialogVisible = true 
           this.formLabelAlign = {
            name:'',
            sort:'',
            id:''
           }
           if(this.$refs['ruleForm']){
           this.$refs['ruleForm'].clearValidate();
         }
        },
        // 编辑
        editPro(data){
             this.edittype = 1  //0表示新增项目，1表示修改项目
           this.tit = "修改证书分类"
           this.centerDialogVisible = true 
           this.formLabelAlign = {
            name:data.name,
            sort:data.sort,
            id:data.id,
           }
               if(this.$refs['ruleForm']){
           this.$refs['ruleForm'].clearValidate();
         }
        },
             // 提交操作
        onsubmit(formName){
              this.$refs[formName].validate((valid) => {
             let params = {};
             let method = "post"
            if(this.edittype == 0)  params = {...this.formLabelAlign},method = "post";
            if(this.edittype == 1)  params = {...this.formLabelAlign},method = "put";
             if(valid){
                if(typeof(this.formLabelAlign.sort) == 'string' && this.formLabelAlign.sort != "") return this.$message.error('排序只能输入数字')
                 //防抖提交
                debounce(() => {
                    this.commentBness(params,method)
                }, 500)
             }
             })
        },
        commentBness(params,method){
            this.loading = true
              editCert(params,method)
                        .then(res => {
                            this.loading = false
                           if(res.code == 0){
                            if(this.edittype == 0) this.$message.success('新增成功'); 
                           if(this.edittype == 1) this.$message.success('修改成功'); 
                                this.gethisInfo()
                                    setTimeout(() => {
                                this.centerDialogVisible = false
                                }, 100);
                           }else{
                            this.$message.error(res.msg)
                           }
                        })
                        .catch(err => {
                          this.loading = false
                        })
        },
        // 删除
        deletPro(data){
             this.$confirm('确定要删除该分类？删除后原该分类下的内容将变为“未分类”状态', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            getCert({
              id:data.id,
              },'delete')
                .then(res => {
                if(res.code == 1) return this.$util.Notifi(res.msg,'error','fa-exclamation-circle')
                 if(res.code == 0){
                   this.$util.Notifi('删除成功','success','fa-check')
                   this.gethisInfo()
                 }
              })
              .catch(err => {
              })
        })
        },
           emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.gethisInfo()
      },
        // 重置
        reset(){
           if(!this.authType){
            this.searchname = ""
              this.currentPage=1
              this.gethisInfo()
        }else{
           this.searchname = ""
          this.gethisInfo1()
        }
        },
        // 搜索
        search(){
        if(!this.authType){
              this.currentPage=1
              this.gethisInfo()
        }else{
          this.gethisInfo1()
        }
        },
        // 获取题目分类
           gethisInfo(){
            getcertClassify({
                name:this.searchname,
                current: this.currentPage,
                size:this.PageSize,
            })
            .then(res => {
              this.itemList = res.data.records
              this.totalCount = res.data.total;
            })
            .catch(err => {
            })
        },
         gethisInfo1(){
          getAllCertClassify({
                name:this.searchname,
            })
            .then(res => {
              this.itemList = res.data
               let rows = []
               rows = res.data.filter(item => this.selsctarr.some(item1 => item.id == item1.id))
                rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row,true)
                })
            })
            .catch(err => {
            })
         }
    }
}
</script>
<style lang="scss" scoped>
.selectTypeClass{
  padding-bottom: 20px;
  .public-btn-div{
    padding-bottom: 0;
    .mft{
      word-break: keep-all;
      margin-left: 0;
    }
  }
}
.app-inner{
    padding: 0 20px;
.businessList_header{
    .el-input{
        width: 200px;
        margin-right: 16px;
        height: 30px;
    }
}
.businessList-container{
    padding: 20px 0;
    .businessList-container-title{
        text-align: right;
        font-size: 18px;
        color: #409eff;
        cursor: pointer;
    }
    .businessList-container-table{
        margin-top: 20px;
    }
    .jiange{
        margin-top: 20px;
    }
}
}
.forminfo{
     .btn{
    width: 80%;
    height: 50px;
    background-color: #409eff;
    border-radius: 0.1vh;
    border: none;
    color: #fff;
    margin: 20px auto;
    margin-bottom: 0;;
    text-align: center;
    line-height: 50px;
    cursor: pointer;
     }
}
::v-deep{
             .el-input__inner{
            height: 30px !important;
            line-height: 30px !important;
        }
        .el-input__icon{
            line-height: 30px;
        }
}
</style>